var safeProbe = function (cb) {
    try {
        return cb();
    }
    catch (e) {
        return undefined;
    }
};

export { safeProbe };
//# sourceMappingURL=safe.js.map
